import axios from 'axios';
import { baseUrl } from '@/config';
import { eq, forEach } from 'lodash';

export default {
  /**
   * [getSmsConfigInfoDeviceList 그룹 > 장비목록 리스트를 출력한다.]
   * @author {Yang}
   * @param  {[ConfigParamVO]} params [managegroupId...]
   * @return {[type]}        [description]
   */
  getSmsConfigInfoDeviceList(params) {
    return axios.post(`${baseUrl}/config/get-sms-config-info-device-list.do`, params);
  },
  /**
   * [exportSmsConfigInfoDeviceList 그룹 > 장비목록 리스트를 엑셀 출력한다.] - 필터링된 데이터만 엑셀출력 가능하도록 수정
   * @author {Yang -> NaJY}
   * @param  {[Integer]} managegroupId [managegroupId]
   * @return {[type]}               [description]
   */
  exportSmsConfigInfoDeviceList(params) {
    return axios.post(`${baseUrl}/config/export-sms-config-info-device-list.do`, params);
  },
  /**
  * 노드>구성현황 기본정보
  * @author hyo
  * @param
  * @return
  */
  getSmsConfigInfoBasic(params) {
    return axios.post(`${baseUrl}/config/get-sms-config-info-basicstatus.do`, params);
  },
  /**
    * 노드>구성현황 HW/SW 정보
    * @author hyo
    * @param
    * @return
    */
  getSmsConfigInfoHwsinfo(params) {
    return axios.post(`${baseUrl}/config/get-sms-config-info-hswinfo.do`, params);
  },

  /**
    * 노드 > 구성현황 수정
    * @author hyo
    * @param
    * @return
    */
  updateSmsConfigInfo(params) {
    return axios.post(`${baseUrl}/config/update-server-obj-config.do`, params);
  },
  /**
   * [getServerInfoList 노드 > OS정보 리스트를 가져온다. / 선택한 obj의 정보를 가져온다.]
   * @author yelim
   * @param  {[type]} params [objId]
   * @return {[type]}
   */
  getServerInfoList(params) {
    return axios.post(`${baseUrl}/config/get-server-info-list.do`, params);
  },
  /**
   * [getOsEnvInfoByObj 노드 > OS정보 환경변수를 가져온다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  getOsEnvInfoByObj(params) {
    return axios.post(`${baseUrl}/config/get-os-env-info-by-obj.do`, params);
  },
  /**
   * [executeOsInfo 노드 > OS정보를 수집한다.]
   * @author Ju
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  executeOsInfo(params) {
    return axios.post(`${baseUrl}/config/execute-os-info.do`, params);
  },
  /**
   * [getHardwareInfoList 노드 > 하드웨어 정보를 가져온다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  getHardwareInfoList(params) {
    return axios.post(`${baseUrl}/config/get-hardware-info-list.do`, params);
  },
  /**
   * [executeOsInfo 노드 > 하드웨어 정보를 수집한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  executeHardwareLoad(params) {
    return axios.post(`${baseUrl}/config/execute-hardware-load.do`, params);
  },
  /**
   * [getSoftwareInfoList 노드 > 소프트웨어 정보를 가져온다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  getSoftwareInfoList(params) {
    return axios.post(`${baseUrl}/config/get-software-info-list.do`, params);
  },
  /**
   * [executeSoftwareInfo 노드 > 소프트웨어 정보를 수집한다.]
   * @author Ju
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  executeSoftwareInfo(params) {
    return axios.post(`${baseUrl}/config/execute-software-load.do`, params);
  },
  /**
   * [getServiceList 노드 > 서비스 목록을 가져온다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  getServiceList(params) {
    return axios.post(`${baseUrl}/config/get-service-list.do`, params);
  },
  /**
   * [getSharedFolderList 노드 > 공유 폴더 목록을 가져온다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  getSharedFolderList(params) {
    return axios.post(`${baseUrl}/config/get-shared-folder-list.do`, params);
  },
  /**
   * [getSchedulingList 노드 > 예약작업 목록을 가져온다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  getSchedulingList(params) {
    return axios.post(`${baseUrl}/config/get-scheduling-list.do`, params);
  },
  /**
   * [exportHardwareInfoList 노드 > 하드웨어 정보를 엑셀 출력한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  exportHardwareInfoList(params) {
    const form = document.createElement('form');
    form.action = `${baseUrl}/config/export-hardware-info-list.do`;
    form.method = 'post';
    forEach(params, (value, key) => {
      if (!eq(key, 'wmiClassName')) {
        const hiddenField = document.createElement('input');
        hiddenField.setAttribute('type', 'hidden');
        hiddenField.setAttribute('name', key);
        hiddenField.setAttribute('value', params[key]);
        form.appendChild(hiddenField);
      }
    });
    document.body.appendChild(form);
    form.submit();

    document.body.removeChild(form);
  },
  /**
   * [exportSoftwareInfoList  노드 > 소프트웨어 정보를 엑셀 출력한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  exportSoftwareInfoList(params) {
    const form = document.createElement('form');
    form.action = `${baseUrl}/config/export-software-info-list.do`;
    form.method = 'post';
    forEach(params, (value, key) => {
      const hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', key);
      hiddenField.setAttribute('value', params[key]);
      form.appendChild(hiddenField);
    });
    document.body.appendChild(form);
    form.submit();

    document.body.removeChild(form);
  },
  /**
   * [exportOsEnvInfo  노드 > OS 정보를 엑셀 출력한다.]
   * @author yelim -> NaJY
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  exportOsEnvInfo(params) {
    return axios.post(`${baseUrl}/config/export-os-env-info.do`, params);
  },
  /**
   * [exportServiceInfoList  노드 > 서비스 정보를 엑셀 출력한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  exportServiceInfoList(params) {
    const form = document.createElement('form');
    form.action = `${baseUrl}/config/export-service-info-list.do`;
    form.method = 'post';
    forEach(params, (value, key) => {
      const hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', key);
      hiddenField.setAttribute('value', params[key]);
      form.appendChild(hiddenField);
    });
    document.body.appendChild(form);
    form.submit();

    document.body.removeChild(form);
  },
  /**
   * [exportSharedFolderInfoList  노드 > 공유폴더 정보를 엑셀 출력한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  exportSharedFolderInfoList(params) {
    const form = document.createElement('form');
    form.action = `${baseUrl}/config/export-shared-folder-info-list.do`;
    form.method = 'post';
    forEach(params, (value, key) => {
      const hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', key);
      hiddenField.setAttribute('value', params[key]);
      form.appendChild(hiddenField);
    });
    document.body.appendChild(form);
    form.submit();

    document.body.removeChild(form);
  },
  /**
   * [exportSchedulingInfoList  노드 > 예약작업 정보를 엑셀 출력한다.]
   * @author yelim
   * @param  {[type]} params [description]
   * @return {[type]}
   */
  exportSchedulingInfoList(params) {
    const form = document.createElement('form');
    form.action = `${baseUrl}/config/export-scheduling-info-list.do`;
    form.method = 'post';
    forEach(params, (value, key) => {
      const hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', key);
      hiddenField.setAttribute('value', params[key]);
      form.appendChild(hiddenField);
    });
    document.body.appendChild(form);
    form.submit();

    document.body.removeChild(form);
  },
  /**
   * 구성정보 > sms > 노드 > 대용량 파일 생성 목록을 가져온다.
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getBulkFileCreationList(params) {
    return axios.post(`${baseUrl}/config/get-bulk-file-creation-list.do`, params);
  },
  /**
   * 구성정보 > sms > 노드 > 파일 접근 종류에 따른 이력 목록을 가져온다.
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getFileAccessList(params) {
    return axios.post(`${baseUrl}/config/get-file-access-list.do`, params);
  },
  /**
   * 구성정보 > 서버 > 노드 > 파일 미변경 목록을 조회한다.
   * @author Ju
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getFileAuditHist(params) {
    return axios.post(`${baseUrl}/config/get-file-audit-hist-list.do`, params);
  },
  /**
   * 구성정보 > 서버 > 노드 > 파일 미변경 목록을 엑셀로 출력한다.
   * @author Ju
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  exportFileAuthHistExcel(params) {
    const form = document.createElement('form');
    form.action = `${baseUrl}/config/export-file-audit-hist-excel.do`;
    form.method = 'post';
    forEach(params, (value, key) => {
      const hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', key);
      hiddenField.setAttribute('value', params[key]);
      form.appendChild(hiddenField);
    });
    document.body.appendChild(form);
    form.submit();

    document.body.removeChild(form);
  },
  /**
   * 구성정보 > sms > 노드 > 대용량 파일 생성 목록을 엑셀 출력한다.
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  exportBulkFileCreationList(params) {
    const form = document.createElement('form');
    form.action = `${baseUrl}/config/export-bulk-file-creation-list.do`;
    form.method = 'post';
    forEach(params, (value, key) => {
      const hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', key);
      hiddenField.setAttribute('value', params[key]);
      form.appendChild(hiddenField);
    });
    document.body.appendChild(form);
    form.submit();

    document.body.removeChild(form);
  },
  /**
   * 구성정보 > sms > 노드 > 접근 구분별 파일 접근이력 목록을 엑셀 출력한다.
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  exportFileAccessList(params) {
    const form = document.createElement('form');
    form.action = `${baseUrl}/config/export-file-access-list.do`;
    form.method = 'post';
    forEach(params, (value, key) => {
      const hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', key);
      hiddenField.setAttribute('value', params[key]);
      form.appendChild(hiddenField);
    });
    document.body.appendChild(form);
    form.submit();

    document.body.removeChild(form);
  },
  /**
  * 구성정보 > sms > 노드 > 파일 접근 종류에 따른 이력 목록을 가져온다.
  * @author jeee12
  * @param  {[type]} params [description]
  * @return {[type]}        [description]
  */
  deleteServerDirAudit(params) {
    return axios.post(`${baseUrl}/config/delete-server-dir-audit.do`, params);
  },
  /**
  * 구성정보 > 서버 > 노드 > 파일 미변경 이력을 삭제한다.
  * @author Ju
  * @param  {[type]} params [description]
  * @return {[type]}        [description]
  */
  deleteFileAuditHist(params) {
    return axios.post(`${baseUrl}/config/delete-file-audit-hist-list.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/config/server/server-info.js